import { render, staticRenderFns } from "./Game_Setting.vue?vue&type=template&id=60d01232&scoped=true&"
import script from "./Game_Setting.vue?vue&type=script&lang=js&"
export * from "./Game_Setting.vue?vue&type=script&lang=js&"
import style0 from "./Game_Setting.vue?vue&type=style&index=0&id=60d01232&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d01232",
  null
  
)

export default component.exports